/*
 * @Author: zhuzhulili www.aaaaiii@foxmail.com
 * @Date: 2025-05-23 11:47:30
 * @LastEditors: zhuzhulili www.aaaaiii@foxmail.com
 * @LastEditTime: 2025-11-29 09:53:30
 * @FilePath: \waifu_waib\src\i18n\jwys\common_en.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  xzsj: 'Select date',//选择时间
  qsr: 'Please enter',//请输入
  qxz: 'Please select',//请选择
  zwsj: 'No data',//暂无数据
  yxqgq: 'The monthly demand is no longer valid for use due to expiration date for handling!',

  gjly: 'International combined transport',//国际联运
  gnys: 'International combined transport',//国内运输
  jdxq: 'Stage demand',//阶段需求
  yxqh:'Monthly demand number',//月需求号
  xqdh: 'Demand doc No',//需求单号
  faz: 'Departure station',//发站
  daoz: 'Arrive at a station',//到站
  pm: 'Product name',//品名
  hwmc: 'Name of goods',//货物名称
  kydcs:'Number of cars',//可预定车数

  fhxx: 'Shipping Information',//发货信息
  shxx: 'Receiving information',//收货信息
  jbr: 'Handler',//经办人
  hz:'Goods owner',//货主
  tyrjs:'Consignor note',//托运人记事
  zjh:'ID Number',//证件号
  tyr:'Shipper',//托运人
  jbrsj:'Mobile phone of handler',//经办人手机
  zzzmwj:'Qualification certification documents',//资质证明文件
  mc:'Name',//名称
  hm:'Number',//号码
  zcdd: 'Loading place',//装车地点
  xcdd: 'Unloading location',//卸车地点
  scfj: 'Upload attachments',//上传附件
  cyshf: 'Common consignee',//常用收货方
  shr: 'Consignee',//收货人
  txdz: 'Mailing address',//通讯地址
  fkxx:'Payment information',//付款信息
  yfk: 'Advance charge',//预付款
  xj:'cash',//现金
  fkr:'payer',//付款人
  zffs: 'Payment method',//支付方式
  bzxz: 'Currency option',//币种选择
  biz:'Currency',//币种
  jp: 'kip',//基普
  rmb: 'RMB',//人民币
  meij: 'dollar',//美元
  ldwl: 'Both ends of the logistics',//两端物流
  ldwlw: 'According to your needs, you can choose to input the delivery, delivery, warehousing and other logistics service information.',//两端物流提示
  qk: 'Empty',//清空
  tj: 'Submit',//提交

  xl: 'Box class',//箱类
  xx: 'A box',//箱型
  zaiz: 'load',//载重
  ziz: 'dead-weigh',//自重
  jwjtdcc:'Drag the file here, or',//将资源文件拖到此处，或
  djsc:'Click upload',//点击上传
  hang:'Row',//行
  xhgscw:'Box number, format error',//箱号，格式错误
  zhyw:'Last number',//最后一位
  ddxx:"Ordering Information",//订单信息
  qhjqkbd:'The information entered will be cleared if you switch the type of transportation. Please confirm!',
  md:'Boten',//磨丁
  nd:'Na Teuy',//纳堆
  lblb:'Luang Prabang',//琅勃拉邦
  wxn:'Vientiane South',//万象南
  mengs:'Muang Xai',
  gax:'Mueang Kasi',
  wanr:'Wanrong',
  pengh:'Phonhong',
  moh: 'Mohan',
  hq:'Get',
  hsxx:'Verify information',

  gryhwfblgjlyyw:'Individual users cannot handle international through traffic services!',
  gryhbzgrshqhqyhh: '个人用户无法办理国际联运业务，请确定与企业绑定经办人，并在个人设置-用户切换中切换成企业用户(en)',
  bqhcqyyhdl:'当前登录用户无发货权限，请确定与企业绑定经办人，并切换成企业用户登录(en)',
  czsb:'Operation failed',
  zyjs:'Remarks',
  fkfs:'Terms of payment',
  yjyf:'预计运费(en)',
  dqyhwfhqx:'ຜູ້ໃຊ້ທີ່ເຂົ້າສູ່ລະບົບໃນປັດຈຸບັນບໍ່ມີສິດການຈັດສົ່ງ ແລະ ບໍ່ສາມາດຈັດການທຸລະການຊົ່ວຄາວໄດ້!',
  bxwdy0os:'Must be an even number greater than 0!',
  qsrtdyy:'Input reason for cancel!',
  bytd:'Cancel this month',
  tdtip:'number of times, no new monthly demand is allowed after 5 times and more of cancel!',
  tdtip2:'Canceled!',
  jdxqsywb:'The demand of this phase has been used up. Please choose other phase demands and fill in accordingly!',
  zntjdtbsj:'The demand of this phase has been used up. Please choose other phase demands and fill in accordingly!',
  zkxzytdd:'Only one piece of data can be selected!',
  yxbtitle2:'只可操作本月及下月的订单!(en)',
  qxzsltgddd:'Please select the accepted order!',
  qxsrsjh:'请先输入手机号(en)',
  qzssr3wzf:'请至少输入三位数字(en)',
  jsqdlx:'Pick-up and delivery type',
}
